module.exports = __webpack_public_path__ + "img/ywbk27_en.7afa663d.jpg";